// NOTE: import only the Firebase modules that you need in your app.
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Initialize Firebase.
// These details will need to be replaced with the project specific env vars at the start of each new cohort.
const firebaseConfig = {
  apiKey: 'AIzaSyD0mia2cHNjMclYYxM50ylT6DiWwlMFSWg',
  authDomain: 'smart-shopping-list-a86dc.firebaseapp.com',
  projectId: 'smart-shopping-list-a86dc',
  storageBucket: 'smart-shopping-list-a86dc.appspot.com',
  messagingSenderId: '848561362726',
  appId: '1:848561362726:web:f6997c57943b13c801d3e7',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore();
